import React from 'react';
import { Row, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import utils from '../../utils';
import ircUtils from '../IRC/ircUtils';
import TagDisplay from '../TagDisplay';
import universalElasticConnectedListUtils from '../UniversalElasticConnectedListUtils';

function FormattedArticleList({list, flatList=true, engineName, searchTerm, showTags=null, showBadges=null, showInWorkspaceNews=false, useStandardNewsLink=true, filterChanged, handleBadgeClick=null}) {


  const getLinkForArticle = (thisItem) => {
    if (useStandardNewsLink && useStandardNewsLink === true) {
      return (
        <Link to={`/news/${thisItem.contentID}`} className="link-primary">
          <h2 className="add-pointer h2">{thisItem.fields.title ? thisItem.fields.title : ''}</h2>
        </Link>
      );
    } else {
      return (
        thisItem.fields.link && thisItem.fields.link.length > 0 && showInWorkspaceNews === true ?
        <Link to={thisItem.fields.link}>
          <h2 className="add-pointer h2">{thisItem.fields.title ? thisItem.fields.title : ''}</h2>
        </Link>
        :
        thisItem.fields.link && thisItem.fields.link.length > 0 && showInWorkspaceNews === false ?
          <Link to={thisItem.fields.link}>
             <h2 className='add-pointer h2'>{thisItem.fields.title ? thisItem.fields.title : ''}</h2>
          </Link>
        : <h3>{thisItem.fields.title ? thisItem.fields.title : ''}</h3>
      )
    }
  }

  
  const handleTagClick = (tag) => {
    if (filterChanged) {
      filterChanged(tag); 
    }
  };

  return list && list.length > 0 ? (
    list.map((thisItem, index) => {
      const tags = thisItem.fields?.tags
        ? utils.limitTags(thisItem.fields.tags, searchTerm) // limits tags to 5
        : ircUtils.getNewsArticleTags(thisItem) || []; 
      return (
        <Row className="app-list-item" key={index}>
          <p className="article-date secondary-link-plain">{utils.getDateString(thisItem.fields.datepublished, 'long', engineName==='ce-articles' ? 'without-day' : null)}</p>
          {getLinkForArticle(thisItem)}
          <p dangerouslySetInnerHTML={{ __html: universalElasticConnectedListUtils.getBodyHTML(thisItem) }}></p>
          {showBadges ? (
            <div className="badge-container m-b-start-02">
              {tags.map((tag, idx) => (
                <Badge
                  key={idx}
                  className="tag-btn tertiary-button border-radius-sm"
                  onClick={() => handleBadgeClick(tag)}
                  style={{ cursor: 'pointer' }}
                >
                  {typeof tag === 'string' ? tag : tag.displayValue || tag} 
                </Badge>
              ))}
            </div> 
          ) : (
            <TagDisplay
              engine={engineName}
              key={index}
              tagList={utils.limitTags(thisItem.fields.tags, searchTerm)}
              flatList={flatList}
              searchTerm={searchTerm}
              handleTagClick={handleTagClick}
            />
          ) }
        </Row>
      );
    })
  ) : (
     <div>No search results available for specified search criteria</div>
  );
}

export default FormattedArticleList;
